/**
 * Rules for offering to install DAMS as an app (DE-1707, ADR-0005).
 *
 * Pure functions: the caller supplies everything read from the browser.
 */

/** Days after "Ikke nå" before the banner is offered again. */
export const DISMISS_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;
const NOTHING = Object.freeze({showBanner: false, showMenuItem: false});

/**
 * How this browser can install DAMS.
 *
 * @param {Object} device
 * @param {boolean} device.hasPromptEvent  The browser fired beforeinstallprompt.
 * @param {string} [device.userAgent]
 * @param {string} [device.platform]
 * @param {number} device.maxTouchPoints
 * @param {boolean} device.isStandalone    DAMS already runs as an installed app.
 * @returns {'prompt'|'ios'|'none'}
 */
export const detectInstallPlatform = ({hasPromptEvent, userAgent, platform, maxTouchPoints, isStandalone}) => {
    if (isStandalone) {
        return 'none';
    }
    if (hasPromptEvent) {
        return 'prompt';
    }
    return isIos(userAgent, platform, maxTouchPoints) ? 'ios' : 'none';
};

/**
 * What to offer: the banner (proactively) and the menu item (on request).
 *
 * @param {Object} state
 * @param {'prompt'|'ios'|'none'} state.platform
 * @param {boolean} state.isCoarsePointer  A phone or tablet.
 * @param {number|null} state.dismissedAt  When the user chose "Ikke nå", in ms since the epoch.
 * @param {number} state.now               Current time, in ms since the epoch.
 * @returns {{showBanner: boolean, showMenuItem: boolean}}
 */
export const installOffer = ({platform, isCoarsePointer, dismissedAt, now}) => {
    if (platform === 'none' || !isCoarsePointer) {
        return NOTHING;
    }
    return {showBanner: !recentlyDismissed(dismissedAt, now), showMenuItem: true};
};

const isIos = (userAgent = '', platform = '', maxTouchPoints) =>
    /iPhone|iPad|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);

const recentlyDismissed = (dismissedAt, now) =>
    Number.isFinite(dismissedAt) && now - dismissedAt < DISMISS_DAYS * DAY_MS;
